export const isH5 = () => {
  const userAgent = navigator.userAgent || navigator.vendor;

  // 移动端设备关键词
  const mobileKeywords = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
    "Mobile",
    "BlackBerry",
    "webOS",
    "Opera Mini",
    "IEMobile",
    "Kindle",
    "Silk",
  ];

  return mobileKeywords.some((keyword) => userAgent.indexOf(keyword) > -1);
};
export enum LoginType {
  "Code" = 0,
  "PassWord" = 1,
  "Phone" = 2,
}

export const day = 1000 * 3600 * 24;
